import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=64775e77&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=ts"
export * from "./CommentItem.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CommentItem.vue?vue&type=style&index=0&id=64775e77&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "64775e77",
  "309d2f56"
  
)

export default component.exports